import { render, staticRenderFns } from "./all-coures.vue?vue&type=template&id=9bc07b92"
import script from "./all-coures.vue?vue&type=script&lang=js"
export * from "./all-coures.vue?vue&type=script&lang=js"
import style0 from "./all-coures.vue?vue&type=style&index=0&id=9bc07b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports